import { render, staticRenderFns } from "./cloudfile.vue?vue&type=template&id=246fb88f&scoped=true"
import script from "./cloudfile.vue?vue&type=script&lang=js"
export * from "./cloudfile.vue?vue&type=script&lang=js"
import style0 from "./cloudfile.vue?vue&type=style&index=0&id=246fb88f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246fb88f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('246fb88f')) {
      api.createRecord('246fb88f', component.options)
    } else {
      api.reload('246fb88f', component.options)
    }
    module.hot.accept("./cloudfile.vue?vue&type=template&id=246fb88f&scoped=true", function () {
      api.rerender('246fb88f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/enterprise/setup/components/cloudfile.vue"
export default component.exports